module.exports = __webpack_public_path__ + "img/14.188f0997.jpg";